import { Box, useMediaQuery } from "@mui/material";
import React from "react";

function LoadingScreen() {
  const isMobile = useMediaQuery('(max-width:800px)');

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#0E101F", // Fond noir
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999, // Mettre le loading screen devant tout
      }}
    >
      <img
        style={{
          objectFit: "cover",
          width: isMobile ? "110px" : "165px",
          height: isMobile ? "140px" : "210px",
        }}
        src={`${process.env.PUBLIC_URL}/runner.gif`}
      />
    </Box>
  );
}

export default LoadingScreen;
